import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';

import EventGridItem from '../EventGridItem';

import './EventGrid.scss';

export interface IEventGridProps {
  events: {
    documentId: string;
    slug: string;
    title: string;
    description: string;
    image: any;
    imageAltText: string;
    payPerView: boolean;
    published: boolean;
    availability: {
      date: string;
      time: string;
    };
  }[];
}

export interface IOrderedEvents {
  documentId: string;
  slug: string;
  title: string;
  description: string;
  image: any;
  imageAltText: string;
  payPerView: boolean;
  published: boolean;
  availability: {
    date: string;
    time: string;
  };
}
[];

const EventGrid = ({ events }: IEventGridProps) => {
  const [orderedEvents, setOrderedEvents] = useState<IOrderedEvents[]>([]);

  // sorts events so that all LIVE events show up first
  useEffect(() => {
    const published =
      events?.filter((event) => event?.published) || [];
    const ordered = [...published].sort((event) =>
      event?.payPerView ? -1 : 1
    );
    setOrderedEvents(ordered);
  }, [events, setOrderedEvents]);

  return (
    <ul className="event-grid">
      {orderedEvents.map((event) => {
        const eventProps = {
          id: event?.documentId,
          CTA: {
            buttonText: '',
            buttonURL: '',
          },
          trailer: {
            id: '',
            mp4: '',
            hls: '',
            dash: '',
          },
          SEO: {
            metaTitle: '',
            metaDescription: '',
          },
          ...event,
        };

        return (
          <li key={event?.documentId}>
            <Link
              to={`/events/${event?.slug}/`}
              aria-label={`${event?.title}`}
            >
              <EventGridItem event={eventProps} />
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default EventGrid;
